import { sentry } from '../services/sentry';
import BaseLasStrategy from './BaseLasStrategy';
import ScLoanError from './utils/scLoanError';

const lasRunner = async <T extends BaseLasStrategy>(lasStrategy: T) => {
  try {
    // cancellation checkpoints between lifecycle phases are owned by the runner;
    // strategies only handle interrupting the in-flight wait inside runInteraction
    lasStrategy.throwIfAborted();
    await lasStrategy.initInteraction();
    lasStrategy.throwIfAborted();
    await lasStrategy.runInteraction();
  } catch (e) {
    if (!(e instanceof ScLoanError)) {
      sentry.loan.captureException(e);
    }
    return lasStrategy.handleInteractionError(e);
  }
  return lasStrategy.finishInteraction();
};

export default lasRunner;
